import { TokenAvatar } from '@/ui/Avatars/TokenAvatar';
import { InfoCircleSolidSmallIcon } from '@/ui/Icons/InfoCircleSolidSmallIcon';
import {
  MatchaTooltip,
  MatchaTooltipBottomSheet,
  MatchaTooltipContent,
  MatchaTooltipPopover,
  MatchaTooltipTrigger,
} from '@/ui/MatchaTooltip';

import { tokenFormatter } from '../../../lib/formatting';
// utils
import { TokenResult } from '../../../utils/0x/token-registry.types';

export const ApproximateAmountTooltip = () => (
  <MatchaTooltip>
    <MatchaTooltipTrigger>
      <button
        type="button"
        aria-label="Why is this buy amount approximate?"
        onClick={(event) => event.stopPropagation()}
        className="ml-1 text-token-gray-700 shrink-0"
      >
        <InfoCircleSolidSmallIcon />
      </button>
    </MatchaTooltipTrigger>
    <MatchaTooltipContent>
      The final amount depends on the market conditions when your order is triggered.
    </MatchaTooltipContent>
    <MatchaTooltipPopover sideOffset={8} />
    <MatchaTooltipBottomSheet header="Estimated buy amount" />
  </MatchaTooltip>
);

interface TokenAmountCellProps {
  /** Sell or buy amount */
  amount: string;
  /** The token object for this cell */
  token?: TokenResult | null;
  /** Whether the amount is an estimate. */
  isApproximate?: boolean;
}

/**
 * Renders the appropriate token icon, formatted amount, and token symbol.
 *
 * @remarks
 *
 * The LimitOrderItem amounts are not formatted so we must include the decimals.
 */
export function TokenAmountCell({ amount, token, isApproximate = false }: TokenAmountCellProps) {
  const formatterOptions = { decimals: token?.decimals, symbol: token?.symbol };
  return (
    <span className="flex items-center">
      <TokenAvatar
        address={token?.address}
        chainId={token?.chainId}
        size={16}
        showChainLogo={false}
      />
      <span className="ml-2">
        {isApproximate ? '~ ' : ''}
        {tokenFormatter.format(amount, formatterOptions)}
      </span>
      {isApproximate && <ApproximateAmountTooltip />}
    </span>
  );
}
